<template>
<div>

  <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          <b-icon icon="chart-bar" />
          Summary
        </p>
      </header>
      <div class="card-content">
        <div class="content">

          <nav class="level">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Users</p>
                <p class="title">{{ users }}</p>
              </div>
            </div>
            <component v-for="(cmp, i) in statComponents" :key="i" :is="cmp"/>
          </nav>

        </div>
      </div>
  </div>

</div>
</template>

<script>
export default {
  data() {
    return {
      users: 0,
    };
  },
  computed: {
    statComponents() {
      return this.$ctforge.findComponents(
        (labels) => labels.type === 'admin_home',
      );
    },
  },
  async mounted() {
    try {
      const users = await this.$ctforge.api.get('/admin/users/list');
      this.users = users.length;
    } catch (e) {
      this.notify(e.message, 'is-danger');
    }
  },
};
</script>

<style>
</style>
